/* login-page.js — 로그인 화면 상호작용 (2026-08-23 외부화)
 *
 * ★왜 파일인가★ — 종전에는 이 약 15KB 가 /login 매 응답의 인라인이었다(콜드 첫 방문
 * 페이로드 감사 — 로그인 인라인 1위). 파일이면 재방문·앱 로그인 재진입에서 불변 ?v=
 * 캐시 적중 = 그 바이트 0. 서버 값은 window.__INS_AUTO_EMAIL__ 한 줄(인라인 잔류)뿐이다.
 * ⚠️ 편집은 이 파일에서 — 인라인 복귀는 매 응답 15KB 재발이다.
 * ⚠️ 보간 문법 금지 — 정적 파일이라 그대로 사용자에게 나간다. */

    /* ── 워밍 핑 (2026-08-23, 사장 지시 「Worker 깨우는 시간을 줄일 수 없나」) ──
       아이디·비밀번호를 치는 몇 초 동안 Worker 를 미리 깨워 둔다. /api/health 는
       SELECT 1 한 문장(상수 비용·인증 무관)이라 Worker 격리체와 D1 경로가 함께 덥혀져,
       로그인 POST 가 콜드 왕복(실측 1~1.3초)을 물지 않는다. 실패는 로그인과 무관 — 침묵. */
    try { fetch('/api/health', { cache: 'no-store' }).catch(function(){}); } catch (e) {}

    /* ── 메신저 세션 끝내기 (R-183 · J-24) ──
       로그인 화면 착지 = 로그아웃 · 세션 만료 · 다른 계정의 길목이다(서비스워커 유무와 무관하게 여기서 돈다).
       기기 기억(insacheck:messenger-frame:v1 · 프레임 스크립트 worker-messenger-frame.js 가 적는다)의 o 가 https 출처면
       숨은 iframe <o>/?embed_logout=1 로 그 메신저 세션을 끝내고 기억을 지운다 · 기억이 없으면 신호 0.
       1.5초 뒤 iframe 을 걷는다 — 로그인을 막지 않는다. 🚫 출처를 소스에 적지 마라(기억의 o 만) · 🚫 입장권을 싣지 마라. */
    (function endMessengerSession() {
      var key = 'insacheck:messenger-frame:v1';
      var o = '';
      try {
        var mem = JSON.parse(localStorage.getItem(key) || 'null');
        o = mem && typeof mem.o === 'string' ? mem.o : '';
        localStorage.removeItem(key);
      } catch (e) {}
      if (!/^https:\/\/[^\/?#\s"'<>]+$/i.test(o) || !document.body) return;
      var f = document.createElement('iframe');
      f.setAttribute('hidden', '');
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.setAttribute('title', '');
      f.setAttribute('src', o + '/?embed_logout=1');
      document.body.appendChild(f);
      setTimeout(function () {
        if (f.parentNode) f.parentNode.removeChild(f);
      }, 1500);
    })();

    /* ── 이메일 로그인 접힘 + 계정 종류 (2026-09-18 탭 제거) ──
       첫 화면은 로그인 하나다(사장 지시). 종전 두 탭의 이메일 폼은 ★하나의 접힘★ 안에서
       「회사 대표·관리자 계정 / 심사·기관용 계정」으로 고른다 — 두 API(login/enterprise ·
       login/worker)를 한 폼으로 합치면 실패 카운터가 한 오타에 두 칸 먹기 때문이다.
       ins:last_login_tab 키는 ★「마지막 로그인 종류」★ 로 뜻만 남는다('enterprise' = 이메일 관리자
       로그인 — login-page.ts 헤드 스크립트가 그 값으로 근로자 자동 복원을 막는다). */
    function pickEmailKind(kind) {
      var isWorker = kind === 'worker';
      var wf = document.getElementById('worker-email-form');
      var ef = document.getElementById('enterprise-login-form');
      if (wf) wf.style.display = isWorker ? 'block' : 'none';
      if (ef) ef.style.display = isWorker ? 'none' : 'block';
      var BRAND = 'var(--brand-600)';
      [['email-kind-worker', isWorker], ['email-kind-enterprise', !isWorker]].forEach(function (pair) {
        var btn = document.getElementById(pair[0]);
        if (!btn) return;
        var on = pair[1];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.style.border = '1px solid ' + (on ? BRAND : '#e2e8f0');
        btn.style.background = on ? BRAND : '#fff';
        btn.style.color = on ? '#fff' : '#475569';
        btn.style.fontWeight = on ? '700' : '500';
      });
      var fold = document.getElementById('email-login-fold');
      if (fold) fold.setAttribute('data-email-kind', isWorker ? 'worker' : 'enterprise');
      hideLoginError();
      try { document.getElementById(isWorker ? 'w-email' : 'e-email').focus(); } catch (e) {}
    }

    function emailFoldShown() {
      var fold = document.getElementById('email-login-fold');
      return !!fold && fold.style.display !== 'none';
    }

    /* ★false 를 돌려준다★ — 토글은 ?email=1 링크이고 onclick 이 `return toggleEmailLogin()` 이다. false 가 링크 이동을 막는다.
       이 파일이 못 오면(로드 실패) 함수가 없어 링크가 그대로 이동하고 서버가 접힘을 펼쳐 그린다(login-page.ts 머리말). */
    function toggleEmailLogin() {
      var fold = document.getElementById('email-login-fold');
      if (!fold) return false;
      var show = fold.style.display === 'none';
      fold.style.display = show ? 'block' : 'none';
      var toggle = document.getElementById('email-login-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) {
        var kind = fold.getAttribute('data-email-kind') === 'worker' ? 'worker' : 'enterprise';
        pickEmailKind(kind);
      } else {
        hideLoginError();
      }
      return false;
    }

    /* ── 페이지 진입 시: 마지막에 이메일 관리자 계정으로 들어온 사람은 그 폼을 펼친 채로 —
       단, logged_out=1 또는 msg 안내가 있으면 모든 자동 입력 / 복원 차단 ── */
    (function autoRestoreLogin(){
      try {
        var urlParams = new URLSearchParams(window.location.search);
        // 로그아웃 직후 → 자동 입력/복원 안 함 (위 head 스크립트에서 이미 localStorage 정리됨)
        if (urlParams.get('logged_out') === '1') return;
        // 가드 리다이렉트(/login?msg=...) 도 마찬가지. 세션이 끊겨 되돌려보낸 상황에서
        // 저장된 종류로 자동 전환하면, 근로자로 다시 로그인하려는 사용자에게도
        // 관리자 이메일 폼 + "기업 관리자 로그인을 다시 확인해주세요" 가 착지 화면으로 뜬다.
        // 서버도 msg 가 있으면 skipAutoLogin 으로 자동 OAuth 를 막는다 — 같은 기준을 맞춘다.
        if (urlParams.get('msg')) return;

        var lastTab = localStorage.getItem('ins:last_login_tab');
        var explicitTab = urlParams.get('tab');
        // 관리자 이메일 자동 입력 — 레거시 이메일 관리자 계정 사용자는 접힘을 펼친 채로 두어
        // 기존 로그인 동선(종전: 기업 탭이 열린 채 이메일 폼 펼침)을 유지한다.
        var lastAdminEmail = localStorage.getItem('ins:last_admin_email');
        var wantsEnterprise = explicitTab ? explicitTab === 'enterprise' : lastTab === 'enterprise';
        if (lastAdminEmail && wantsEnterprise) {
          var eEmail = document.getElementById('e-email');
          if (eEmail && !eEmail.value) eEmail.value = lastAdminEmail;
          var fold = document.getElementById('email-login-fold');
          if (fold) fold.setAttribute('data-email-kind', 'enterprise');
          if (!emailFoldShown()) toggleEmailLogin();
        }
        // 심사·기관용 이메일 (만약 form 에 있다면)
        var lastWorkerEmail = localStorage.getItem('ins:last_worker_email');
        if (lastWorkerEmail) {
          var wEmail = document.getElementById('w-email');
          if (wEmail && !wEmail.value) wEmail.value = lastWorkerEmail;
        }
      } catch(e) {}
    })();

    /* ── 비밀번호 토글 ── */
    function togglePw(id, btn) {
      var input = document.getElementById(id);
      var icon  = btn.querySelector('i');
      input.type = input.type === 'password' ? 'text' : 'password';
      icon.className = input.type === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash';
    }

    /* ── 에러 표시 ── */
    function showLoginError(msg) {
      var el = document.getElementById('login-error');
      document.getElementById('login-error-msg').textContent = msg;
      el.style.display = 'flex';
    }
    function hideLoginError() {
      document.getElementById('login-error').style.display = 'none';
    }

    /* ── 사람 확인(Turnstile · R-168 F9 ⓑ) — 위젯이 없으면(키 없음·앱) 빈 토큰을 보낸다(서버도 그때는 안 본다 · 정본 src/lib/turnstile.ts).
       토큰은 한 번 쓰면 끝이라 응답을 받을 때마다 위젯을 새로 돌린다. ── */
    function turnstileToken() {
      var el = document.querySelector('[data-ins-turnstile] [name="cf-turnstile-response"]');
      return el ? el.value : '';
    }
    function turnstileReset() {
      try { if (window.turnstile && document.querySelector('[data-ins-turnstile]')) window.turnstile.reset(); } catch (e) {}
    }
    /* ── 429(요청이 너무 많음) — 앱 계수기의 JSON 은 그 문구 그대로, 존 WAF 의 HTML 429(R-168 F9 ⓒ)는 「잠시 뒤 다시」.
       🚫 429 를 r.json() 에 그대로 넘기지 마라 — HTML 이면 해석 실패가 catch 로 가서 「네트워크 오류」로 보인다. ── */
    var RATE_LIMITED_TEXT = '요청이 너무 많아요. 잠시 뒤(10초) 다시 시도해 주세요.';
    function readAuthJson(r) {
      turnstileReset();
      if (r.status === 429) {
        return r.json().catch(function() { return {}; }).then(function(d) {
          return { success: false, error: (d && d.error) || RATE_LIMITED_TEXT };
        });
      }
      return r.json().then(function(d) { return (r.status === 401 && d && (d.code === 'TWO_FACTOR_REQUIRED' || d.code === 'TWO_FACTOR_ENROLL_REQUIRED')) ? twoFactorResolve(d) : d; });
    }

    /* ── 2단계 인증(R-588) — 로그인 응답이 401 TWO_FACTOR_REQUIRED / TWO_FACTOR_ENROLL_REQUIRED 면 6자리 시트를 띄우고,
       맞게 넣으면 ★원래 로그인 성공 본문★ 으로 풀려 기존 성공 분기가 그대로 이어진다(쿠키는 그 응답 때 브라우저가 받는다).
       시트 코드(public/static/two-factor-prompt.js · window.InsaTwoFactor)는 이때만 늦게 불러 — 2단계를 안 쓰는 사람의 화면 HTML 은 그대로다.
       ★그 파일을 고치면 아래 버전 상수를 올린다★(/static/* 은 1년 캐시). ── */
    var TF_PROMPT_VERSION = 'r588a';
    function twoFactorResolve(d) {
      return new Promise(function(resolve) {
        function run() { window.InsaTwoFactor.resolve(d).then(resolve); }
        if (window.InsaTwoFactor) { run(); return; }
        var s = document.createElement('script');
        s.setAttribute('src', '/static/two-factor-prompt.js?v=' + TF_PROMPT_VERSION);
        s.onload = run;
        s.onerror = function() { resolve({ success: false, error: d.error || '2단계 인증 화면을 불러오지 못했습니다. 새로고침 후 다시 시도해 주세요.' }); };
        document.head.appendChild(s);
      });
    }

    /* ── 푸터 연도 자동 표시 (Phase 3.1) ── */
    document.querySelectorAll('.footer-year').forEach(function(el){
      el.textContent = /*t:DEVICE_NOW*/new Date()/*t*/.getFullYear();
    });

    /* ── 소셜 버튼 로딩 watchdog (2026-08-04 로그아웃 후 네이버 무한 로딩 수리)
       앱 WebView 는 /auth/kakao·/auth/naver 이동을 가로채(NavigationDecision.prevent)
       네이티브 OAuth 로 대체한다. 네이티브 시도가 조용히 무시되면(코디네이터 고착 등)
       이 문서는 그대로 남는데, 종전엔 버튼을 disabled+스피너로 바꾼 뒤 되돌릴 장치가
       없어 "네이버 로그인 중..." 스피너가 영구 잔류했다. 일반 브라우저의 bfcache
       뒤로가기 복귀(pageshow persisted)도 같은 잔류를 만든다. 트리거 시점에 무조건
       타이머를 걸고 제한 시간 안에 문서가 교체되지 않으면 버튼을 원상 복구해
       재시도 가능 상태로 되돌린다(정상 이동 시 문서가 파기되므로 타이머는 자연 소멸). */
    var SOCIAL_LOGIN_WATCHDOG_MS = 8000;
    var SOCIAL_LOGIN_BTN_IDS = ['kakao-login-btn', 'naver-login-btn'];
    function restoreSocialLoginButtons() {
      SOCIAL_LOGIN_BTN_IDS.forEach(function(id){
        var btn = document.getElementById(id);
        if (!btn) return;
        var orig = btn.getAttribute('data-orig-html');
        if (orig === null) return;
        btn.innerHTML = orig;
        btn.removeAttribute('data-orig-html');
        btn.disabled = false;
      });
    }
    /* ── ★복귀 재확인★ (2026-08-29 사장 신고) ─────────────────────────────
       신고: 「카톡 로그인 화면에서 멈추거나 네이버 로그인 화면에서 멈춘다.
              핸드폰 홈 화면 나갔다 들어오면 로그인이 되는데 화면이 즉시 안 바뀐다」

       ★기제★ — 로그인 성공은 ★서버가 쿠키를 심는 것★ 으로 끝난다. 그런데 사용자가
       보고 있는 이 문서는 ★그 사실을 모른다.★ 이 화면에는 이미 그물이 두 겹 있는데
       ★둘 다 이 순간을 못 잡는다★:
         ① 서버 302 (login-page.ts 의 「로그인 상태로 /login 에 도달」 안전망)
            — ★새 요청이 있어야★ 돈다. bfcache 복귀·앱 복귀는 요청이 없다.
         ② 바로 위 pageshow 핸들러 — ★버튼 스피너만★ 되돌린다. 세션은 보지 않는다.
       그래서 화면이 「로그인 폼」 그대로 남는다. 앱이 복귀하면서 렌더러를 되살리고
       URL 을 재로드할 때(webview_screen.dart `_recoverFromAndroidRendererTermination`)
       비로소 ①이 돌아 로그인된 화면으로 바뀐다 — 그것이 사장이 본 「나갔다 들어오면 된다」다.

       ★고치는 방식★ — 복귀 시 ★재로드해서 ①이 돌게 한다.★
       ⚠️ ★세션 판정을 여기서 다시 구현하지 않는다★ — 판정 정본은 서버이고, 사본을
          만들면 두 판정이 갈린다(이 저장소가 반복해서 데인 자리다).
       ⚠️ ★소셜 로그인을 실제로 떠난 탭에서만★ 돈다 — 그냥 로그인 화면을 보고 있던
          사람은 아무 영향이 없다.
       ⚠️ ★스로틀★ — 인증 도중 잠깐 앱을 오갈 수 있다. 한 번만 돌게 잠그면 그 사람은
          정작 ★진짜 복귀 때 재확인을 못 받는다.★ 그래서 「1회 제한」이 아니라
          ★최소 간격★ 으로 막는다(무한 새로고침도 같이 막힌다).
       ⚠️ ★문서가 갓 뜬 직후에는 돌지 않는다★ — 로드 직후의 visibilitychange 로
          재로드가 연쇄하는 것을 막는다. */
    var SOCIAL_ATTEMPT_KEY = 'ins:social_attempt';
    var SOCIAL_RELOAD_AT_KEY = 'ins:social_return_reloaded_at';
    var SOCIAL_RETURN_MIN_GAP_MS = 4000;   /* 재로드 최소 간격 */
    var SOCIAL_RETURN_MIN_AGE_MS = 1200;   /* 이 문서가 뜬 뒤 최소 경과 */
    var docReadyAt = Date.now();

    function markSocialAttempt() {
      try {
        sessionStorage.setItem(SOCIAL_ATTEMPT_KEY, '1');
        sessionStorage.removeItem(SOCIAL_RELOAD_AT_KEY);
      } catch (e) {}
    }

    function recheckLoginAfterReturn() {
      var attempted = false;
      var lastAt = 0;
      try {
        attempted = sessionStorage.getItem(SOCIAL_ATTEMPT_KEY) === '1';
        lastAt = parseInt(sessionStorage.getItem(SOCIAL_RELOAD_AT_KEY) || '0', 10) || 0;
      } catch (e) { return; }
      if (!attempted) return;
      var now = Date.now();
      if (now - docReadyAt < SOCIAL_RETURN_MIN_AGE_MS) return;
      if (now - lastAt < SOCIAL_RETURN_MIN_GAP_MS) return;
      try { sessionStorage.setItem(SOCIAL_RELOAD_AT_KEY, String(now)); } catch (e) {}
      /* ★replace 로 재로드한다★ — reload() 는 히스토리 항목을 그대로 두지만
         replace 는 남기지 않아, 뒤로 가기가 「멈춰 있던 그 화면」으로 되돌아가지 않는다. */
      location.replace(location.href);
    }

    window.addEventListener('pageshow', function(e){
      if (e && e.persisted) { restoreSocialLoginButtons(); recheckLoginAfterReturn(); }
    });
    /* 앱 WebView 는 소셜 로그인을 ★외부 브라우저★ 로 내보내므로(webview_screen.dart)
       이 문서는 살아 있고 bfcache 도 아니다 — 그때는 visibilitychange 가 유일한 신호다. */
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'visible') recheckLoginAfterReturn();
    });

    /* ── 소셜 로그인 (카카오 / 네이버) — OAuth 서버 리다이렉트
       ★기업 컨텍스트(context='enterprise' → next=/signup/enterprise?src=social-login)는 없어졌다★
       (2026-09-18 탭 제거). 로그인 뒤 갈림은 서버가 정한다 — 신규 회원만 /welcome 카드
       (src/lib/new-member-landing.ts), 기존 회원은 종전 자리. /signup/enterprise 화면의
       자체 소셜 버튼과 데스크톱 앱은 여전히 그 next 관례를 직접 쓴다(그쪽은 안 바뀐다). ── */
    /* ★false 를 돌려준다★ — 버튼은 OAuth 시작 주소로 가는 링크이고 onclick 이 `return socialLogin(…)` 이다.
       false 가 링크 기본 이동을 막고 아래 replace 가 이동한다(히스토리 정리 · 표식 · 스피너). 이 파일이 못 오면 링크가 그대로 간다. */
    function socialLogin(provider) {
      var providerName = provider === 'kakao' ? '카카오' : '네이버';
      var btn = document.getElementById(provider + '-login-btn');
      if (btn) {
        if (btn.disabled) return false; // 워치독 해제 전 재클릭(더블탭) 무시 — 링크 이동도 막는다
        btn.setAttribute('data-orig-html', btn.innerHTML);
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin" style="margin-right:8px"></i>' + providerName + ' 로그인 중...';
        setTimeout(restoreSocialLoginButtons, SOCIAL_LOGIN_WATCHDOG_MS);
      }
      /* 마지막 로그인 종류 = 소셜(근로자) — 종전 「기업 탭 소셜」이 남긴 'enterprise' 값이
         영구히 자동 재로그인을 막던 것을 여기서 되돌린다(이메일 관리자 로그인이 다시 덮어쓴다). */
      try { localStorage.setItem('ins:last_login_tab', 'worker'); } catch(e) {}
      var authUrl = '/auth/' + provider;
      // 서버 OAuth 인가 엔드포인트로 리다이렉트 (기존 next 복귀 관례)
      var urlParams = new URLSearchParams(window.location.search);
      var nextParam = urlParams.get('next');
      if (nextParam && nextParam.charAt(0) === '/' && nextParam.charAt(1) !== '/'
          && (nextParam.indexOf('/worker') === 0 || nextParam.indexOf('/nfc/') === 0 || nextParam.indexOf('/oauth/authorize') === 0 || nextParam.indexOf('/mcp/oauth/authorize') === 0)) {
        authUrl += '?next=' + encodeURIComponent(nextParam);
      }
      /* ★이 탭이 소셜 로그인을 떠났다★ 는 표식 — 복귀 재확인(recheckLoginAfterReturn)이
         이걸 보고만 돈다. 앱 WebView 는 아래 이동을 가로채므로(NavigationDecision.prevent)
         ★이 문서가 살아남는다★ — 그 경우에도 표식은 남아 복귀 때 재확인이 돈다. */
      markSocialAttempt();
      /* replace — OAuth 로 떠날 때 /login 을 히스토리에서 치운다. 콜백이 되돌아온 뒤
         뒤로 가기를 눌렀을 때 로그인 폼(이미 로그인된 막다른 화면)으로 가지 않게 한다. */
      window.location.replace(authUrl);
      return false;
    }

    /* ── 회사 대표·관리자(이메일) 로그인 — POST /api/auth/login/enterprise ── */
    function handleEnterpriseLogin(e) {
      e.preventDefault();
      hideLoginError();
      // 2026-05-20: 모바일 키보드 변형 흡수 — trim 후 lowercase (server 와 동일 정규화).
      //   갤럭시 삼성키보드 trailing space / iOS auto-correct 첫 글자 대문자 케이스 모두 흡수.
      var email    = document.getElementById('e-email').value.trim().toLowerCase();
      var password = document.getElementById('e-password').value;
      var btnText  = document.getElementById('e-btn-text');
      var btnLoad  = document.getElementById('e-btn-loading');
      btnText.style.display = 'none'; btnLoad.style.display = 'inline';

      fetch('/api/auth/login/enterprise', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, turnstile_token: turnstileToken() })
      })
      .then(readAuthJson)
      .then(function(data) {
        btnText.style.display = 'inline'; btnLoad.style.display = 'none';
        if (data.success) {
          try {
            localStorage.setItem('ins:last_admin_email', email);
            localStorage.setItem('ins:last_login_tab', 'enterprise');
            localStorage.removeItem('ins:ent_session_v1');
          } catch(e) {}
          // next 파라미터 있으면 그 페이지로 복귀 (세션 만료 흐름 후 작업 위치 보존)
          var urlParams = new URLSearchParams(window.location.search);
          var next = urlParams.get('next');
          // 안전: same-origin 만 허용 (open redirect 차단)
          var redirectTo = '/admin/enterprise';
          if (next && next.charAt(0) === '/' && next.charAt(1) !== '/'
              && (next.indexOf('/admin/enterprise') === 0 || next.indexOf('/oauth/authorize') === 0 || next.indexOf('/mcp/oauth/authorize') === 0)) {
            redirectTo = next;
          }
          /* replace — 로그인 성공 후 /login 을 히스토리에 남기지 않는다. 남기면 뒤로
             가기가 '직전 화면'이 아니라 로그인 폼으로 떨어진다(2026-08-04 사장 실기기). */
          window.location.replace(redirectTo);
        } else {
          showLoginError(data.error || '로그인에 실패했습니다.');
        }
      })
      .catch(function() {
        turnstileReset();
        btnText.style.display = 'inline'; btnLoad.style.display = 'none';
        showLoginError('네트워크 오류가 발생했습니다.');
      });
    }

    /* ── 심사·기관용(이메일) 로그인 — POST /api/auth/login/worker ── */
    function handleWorkerEmailLogin(e) {
      e.preventDefault();
      hideLoginError();
      // 모바일 키보드 변형 흡수 — trim + lowercase (server 와 동일 정규화, handleEnterpriseLogin 과 동일)
      var email    = document.getElementById('w-email').value.trim().toLowerCase();
      var password = document.getElementById('w-password').value;
      var btnText  = document.getElementById('w-btn-text');
      var btnLoad  = document.getElementById('w-btn-loading');
      btnText.style.display = 'none'; btnLoad.style.display = 'inline';

      fetch('/api/auth/login/worker', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, password: password, turnstile_token: turnstileToken() })
      })
      .then(readAuthJson)
      .then(function(data) {
        btnText.style.display = 'inline'; btnLoad.style.display = 'none';
        if (data.success) {
          try {
            localStorage.setItem('ins:last_worker_email', email);
            localStorage.setItem('ins:last_login_tab', 'worker');
          } catch(e) {}
          // next 파라미터 있으면 그 페이지로 복귀 — socialLogin 과 동일한 same-origin 허용 목록
          var urlParams = new URLSearchParams(window.location.search);
          var next = urlParams.get('next');
          var redirectTo = '/worker';
          if (next && next.charAt(0) === '/' && next.charAt(1) !== '/'
              && (next.indexOf('/worker') === 0 || next.indexOf('/nfc/') === 0 || next.indexOf('/oauth/authorize') === 0 || next.indexOf('/mcp/oauth/authorize') === 0)) {
            redirectTo = next;
          }
          /* replace — 로그인 성공 후 /login 을 히스토리에 남기지 않는다. 남기면 뒤로
             가기가 '직전 화면'이 아니라 로그인 폼으로 떨어진다(2026-08-04 사장 실기기). */
          window.location.replace(redirectTo);
        } else {
          showLoginError(data.error || '로그인에 실패했습니다.');
        }
      })
      .catch(function() {
        turnstileReset();
        btnText.style.display = 'inline'; btnLoad.style.display = 'none';
        showLoginError('네트워크 오류가 발생했습니다.');
      });
    }

    /* ?email=1 → 이메일 폼을 펼친 채로 시작한다.
       데스크톱 앱 첫 화면의 [이메일로 로그인] 이 이 URL 로 온다 — 거기서는 이미
       "이메일로 로그인하겠다"를 고른 뒤이므로 여기서 또 누르게 하면 안 된다.
       어느 종류를 먼저 보일지는 서버가 ?tab= 으로 정해 data-email-kind 에 심어 둔다.
       ⚠ 서버가 __INS_AUTO_EMAIL__ 을 1 로 심었을 때만 돈다(파라미터 없으면 미주입). */
    (function(){
      if (window.__INS_AUTO_EMAIL__ !== 1) return;
      try {
        if (!emailFoldShown()) toggleEmailLogin();
      } catch(e) {}
    })();

    /* 이 파일이 섰다 = 두 폼의 제출을 받는다 ⇒ 「새로고침」 안내를 지운다(안내는 이 파일이 끝내 안 올 때만 남는다 · login-page.ts). */
    (function(){
      var hint = document.getElementById('email-login-js-hint');
      if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
    })();
